import { useBoolean } from 'ahooks'
import { Button } from 'antd'

import { browserOpen } from '@eastcoal/common/utils/browser'
import { pick } from '@eastcoal/common/utils/object'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { EntranceType, EntranceTypeTextMap } from '../../enums/EntranceType'
import { useAuctionDetailAuthenticatorStore } from '../AuctionDetailAuthenticator/Store/hooks/useStore'

import { AuctionDetailNavigatorProps } from './interface'

export const AuctionDetailNavigator = ({
  type,
  ghost,
  to,
  bizId,
  bizType,
  auctionTitle,
  entranceType
}: AuctionDetailNavigatorProps) => {
  const { ref: auctionDetailAuthenticatorRef } =
    useAuctionDetailAuthenticatorStore(state => pick(state, ['ref']))
  const [loading, loadingActions] = useBoolean(false)
  const handleClick = async () => {
    const openInNewTab = () => {
      browserOpen(
        stringifyUrl({
          url: to,
          query: {
            bizType,
            auctionTitle
          }
        }),
        '_blank'
      )
    }
    if (entranceType === EntranceType.WATCH) {
      openInNewTab()
      return
    }
    try {
      loadingActions.setTrue()
      await auctionDetailAuthenticatorRef.current?.doCheck({
        bizId,
        bizType,
        auctionTitle
      })
      setTimeout(openInNewTab, 100)
    } finally {
      loadingActions.setFalse()
    }
  }

  return (
    <Button ghost={ghost} loading={loading} type={type} onClick={handleClick}>
      {EntranceTypeTextMap[entranceType]}
    </Button>
  )
}
